import { ToDoList } from 'enrollment/features';
// import ListAnimation from 'assets/ListAnimation.gif';
import { BenefitsPageResponseDto } from 'theSource/queries';

interface HomeToDoListProps {
  benefitsData?: BenefitsPageResponseDto;
}

export const HomeToDoList = ({ benefitsData }: HomeToDoListProps) => {
  return (
      <div data-testid="homepage-to-do-list" className="col col-lg-12 px-0">
        <ToDoList benefitsData={benefitsData} />
      </div>
  );
};
